<template>
  <div>
    <div v-if="totalTable.total">
      <LoadingAnimation v-if="!(readyAllPDF && readyMainPDF)"/>
      <pdf-gen
        :content-data="Array(getMainTable(left, right), getGeneralNote(), totalTable.total)"
        signature
        :name="fileName + '.pdf'"
        ref="pdf-main"
        :sign-data="signData"
        :invisible="invisible"
      />
      <div v-if="readyMainPDF" :key="readyMainPDF">
        <v-sheet
          v-if="readyAllPDF && !formed"
          width="100%" max-width="800"
          class="d-flex mx-auto justify-start justify-md-end mt-5 mb-10"
          color="transparent"
        >
          <v-hover v-slot="{ hover }">
            <v-btn
              @click="$refs['pdf-main'].onDownload()"
              :elevation="0" fab dark
              color="#277FAF"
              :outlined="hover"
              :width="size"
              :height="size"
            >
              <IconsButton icon="button-create_pdf" color="currentColor"/>
            </v-btn>
          </v-hover>
        </v-sheet>
        <div v-for="(employee, e) in data.employees" :key="'employee' + e" class="mt-5">
          <pdf-gen
            v-if="totalTable[e] && daysTable[e]"
            :content-data="Array(
                    employees && employees[e] ? getMainTable(left.concat(employees[e].first_name + ' ' + employees[e].last_name), right) : '-',
                    totalTable[e],
                    daysTable[e],
                    imagesTotal[e] > 0 ? imagesTable[e] : null
                    )"
            signature
            :ref="'pdf-' + e"
            :sign-data="signData"
            :invisible="invisible"
            :images="imagesList"
          />
        </div>
      </div>
      <div v-if="!formed" class="fixedBtn">
        <StatisticProjectReportsApproveModal
          :size="size"
          :works="confirmed"
          :notes="notes"
        />
        <StatisticProjectReportsSignSendModal
          :report_id="$route.params.report_id"
          :work_client_id="project.client.id"
          round
          :size="size"
          :works="confirmed"
          :sign-data="signData"
          :notes="notes"
        />
        <v-btn
          @click="onDownload()"
          :elevation="0" fab
          :width="size"
          :height="size"
          class="mt-5"
        >
          <IconsButton icon="button-create_pdf" color="currentColor"/>
        </v-btn>
        <v-btn
          :to="{name: 'timeControlShowReportsView'}"
          :elevation="0" fab
          :width="size"
          :height="size"
        >
          <v-icon :size="$vuetify.breakpoint.smAndDown ? 25 : 35">mdi-pencil</v-icon>
        </v-btn>
      </div>
      <div v-if="$route.name === 'timeControlShowReportsViewBill'" class="fixedBtn">
        <slot name="fixed_btn"/>
        <v-btn
          @click="onDownload()"
          :elevation="0" fab
          :width="size"
          :height="size"
        >
          <IconsButton icon="button-create_pdf" color="currentColor"/>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import PdfGen from "components/pdf/pdfGen";
import LoadingAnimation from "components/LoadingAnimation";
import IconsButton from "components/icons/button/IconsButton";
import {PDFDocument} from 'pdf-lib'
import StatisticProjectReportsSignSendModal from "../../StatisticProjectReportsSignSendModal";
import StatisticProjectReportsApproveModal from "components/timeControl/reports/StatisticProjectReportsApproveModal";

export default {
  name: "StatisticProjectReportsBlankPDF",
  components: {
    StatisticProjectReportsApproveModal,
    StatisticProjectReportsSignSendModal,
    IconsButton,
    LoadingAnimation,
    PdfGen,
  },
  props: {
    project: {
      type: Object,
      default: () => {
        return {}
      }
    },
    date: {
      type: String,
      default: ''
    },
    employees: {
      type: Array,
      default: () => {
        return []
      }
    },
    confirmed: {
      type: Object,
      default: () => {
        return {
          work_types: [],
          extras: []
        }
      }
    },
    formed: Boolean,
    signData: Object,
    notes: Boolean,
    total_works: {
      type: Array,
      default: () => {
        return null
      }
    },
    total_extras: {
      type: Array,
      default: () => {
        return null
      }
    },
    invisible: Boolean,
    general: {
      type: String,
      default: '',
    },
    images: Boolean,
    imagesCount: {
      type: Object,
      default: () => {
        return {
          key: 0,
          value: {}
        }
      }
    }
  },
  data: () => ({
    documents: [],
    hasNotes: false,
    images_count: {},
    imagesList: {blank: 'https://api.dev.proapp.fi/min/uploads/ZCnJQrws6Zn7lHOOlDeZIlaTSfFI8MzJtaScxwfb.jpg'}
  }),
  computed: {
    ...mapGetters('workClientProjectsClientReports', ['workClientProjectsClientReportsGeneralNote']),
    apiDomain() {
      return this.$store.state.apiDomain
    },
    field() {
      return this.formed ? 'report' : 'approved_report'
    },
    size() {
      return this.$vuetify.breakpoint.smAndDown ? 45 : 60
    },
    fileName() {
      return this.project.name + ' ' + this.date
    },
    left() {
      return Array(
        this.project.name,
        this.project.street + ', ' + this.project.zip + ', ' + this.project.city,
        this.date
      )
    },
    right() {
      return Array(
        this.project.client.name,
        (this?.project?.manager?.first_name || '-') + ' ' + (this?.project?.manager?.last_name || ''),
        this?.project?.manager?.phone || '-'
      )
    },
    data() {
      let data = {
        work_types: {},
        extras: {}
      }
      let employees = {}
      for (let e in this.employees) {
        employees[e] = {
          byDays: {},
          total: {
            work_types: {},
            extras: {},
          }
        }
        for (let type in data) {
          let works = this.employees[e][type]
          for (let w in works) {
            let days = works[w].days
            let kk = works[w].name
            for (let d in days) {
              for (let report in days[d].reports) {
                if (this.confirmed[type].includes(days[d].reports[report].id) || this.formed) {
                  let day = d.split('-')
                  if (!employees[e].byDays[d]) employees[e].byDays[d] = {day: day[2] + '.' + day[1]}
                  if (!employees[e].byDays[d][type]) employees[e].byDays[d][type] = {}
                  if (!employees[e].byDays[d][type][kk])
                    employees[e].byDays[d][type][kk] = {
                      name: works[w].name,
                      measure: works[w].measure,
                      is_hourly: works[w].is_hourly,
                      reports: []
                    }
                  if (!employees[e].total[type][kk]) employees[e].total[type][kk] = {
                    name: works[w].name,
                    measure: works[w].measure,
                    is_hourly: works[w].is_hourly,
                    [this.field]: 0
                  }
                  if (!data[type][kk])
                    data[type][kk] = {
                      name: works[w].name,
                      measure: works[w].measure,
                      is_hourly: works[w].is_hourly,
                      [this.field]: 0
                    }
                  if (days[d].reports[report].notes && days[d].reports[report].notes.length > 0) {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.hasNotes = true
                  }
                  console.log('AAAAAAAA typeof days[d].reports[report].image', typeof days[d].reports[report].image)
                  //let qqq = days[d].reports[report].image && typeof days[d].reports[report].image === 'string' ? JSON.parse(days[d].reports[report].image).images || [] : days[d].reports[report].image ||[]
                  let qqq = days[d]?.reports[report]?.image?.images || []
                  console.log('QQQ', qqq)
                  if (qqq) {
                    for (let q in qqq) {
                      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                      this.imagesList[qqq[q]] = this.apiDomain + '/min/' + qqq[q]
                    }
                  }
                  //console.log('days[d].reports[report]', days[d].reports[report].image)
                  if (!this.images_count[e]) {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.images_count[e] = []
                  }
                  // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                  this.images_count[e].push(qqq.length)
                  employees[e].byDays[d][type][kk].reports.push({
                    id: days[d].reports[report].id,
                    value: days[d].reports[report][this.field],
                    image: qqq,
                    notes: days[d].reports[report].notes || days[d].reports[report]['work_extras_report_notes'] || days[d].reports[report]['employee_work_day_reports_notes']
                  })
                  employees[e].total[type][kk][this.field] += days[d].reports[report][this.field]
                  data[type][kk][this.field] += days[d].reports[report][this.field]
                }
              }
            }
          }
        }
      }
      let temp = {
        work_types: {},
        extras: {},
      }
      let wl = Object.keys(data.work_types).sort(function (a, b) {
        let nA = a.toLowerCase()
        let nB = b.toLowerCase()
        if (nA < nB) return -1
        if (nA > nB) return 1
        return 0
      })
      for (let i in wl) {
        temp.work_types[wl[i]] = data.work_types[wl[i]]
      }
      let el = Object.keys(data.extras).sort(function (a, b) {
        let nA = a.toLowerCase()
        let nB = b.toLowerCase()
        if (nA < nB) return -1
        if (nA > nB) return 1
        return 0
      })
      for (let i in el) {
        temp.extras[el[i]] = data.extras[el[i]]
      }
      return {
        total: temp,
        employees: employees,
      }
    },
    totalTable() {
      let data = {
        total: this.getTotalTable(this.total_works || this.total_extras
          ? {work_types: this.total_works || [], extras: this.total_extras || []}
          : this.data.total)
      }
      for (let e in this.data.employees) {
        data[e] = this.getTotalTable(this.data.employees[e].total)
      }
      return data
    },
    daysTable() {
      let data = {}
      for (let e in this.data.employees) {
        data[e] = this.getDaysTable(this.data.employees[e].byDays)
      }
      return data
    },
    imagesTotal() {
      const res = {}
      for (let e in this.images_count) {
        res[e] = Math.max(...this.images_count[e]) > 5 ? 5 : Math.max(...this.images_count[e])
      }
      return res
    },
    imagesTable() {
      let data = {}
      for (let e in this.data.employees) {
        data[e] = this.images ? this.getImagesTable(this.data.employees[e], e) : []
      }
      return data
    },
    readyMainPDF() {
      let result = false
      if (this.$refs['pdf-main'])
        result = this.$refs['pdf-main'].documentReady
      return result
    },
    readyAllPDF() {
      let result = []
      for (let i in this.data.employees)
        if (this.$refs && this.$refs['pdf-' + i])
          result.push(this.$refs['pdf-' + i][0] ? this.$refs['pdf-' + i][0].documentReady : false)
      return result.every((cur) => {
        return cur === true
      })
    },
    t() {
      return this.localStorage.translations.pages.finance['period-table']
    }
  },
  methods: {
    getMainTable(left, right) {
      let data = {
        left: {
          text: [this.t.project, this.t.address, this.t.term, this.t.employee],
          value: left
        },
        right: {
          text: [this.t.client, this.t.subscriber, this.t['tel']],
          value: right
        }
      }
      let table = {
        left: {},
        right: {}
      }
      for (let side in table) {
        table[side].table = {
          widths: [70, '*'],
          body: []
        }
        table[side].layout = {
          hLineColor: '#d2d5d9',
          hLineWidth: function (i) {
            return i === 0 ? 0 : 0.25
          },
          vLineWidth: function () {
            return 0
          },
          paddingTop: function () {
            return 0
          },
          paddingBottom: function () {
            return 0
          },
        }
        for (let i in data[side].value) {
          table[side].table.body.push([
            {text: data[side].text[i], style: 'mt'},
            {text: data[side].value[i], style: 'mt'},
          ])
        }
      }
      return {
        style: 'header',
        table: {
          widths: ['*', '*'],
          body: [
            [table.left, table.right]
          ]
        },
        layout: {
          vLineColor: '#d2d5d9',
          vLineWidth: function (i) {
            return i === 1 ? 0.25 : 0
          },
          hLineWidth: function () {
            return 0
          },
          paddingLeft: function (i) {
            return i === 0 ? 0 : 4
          },
          paddingRight: function (i) {
            return i === 0 ? 4 : 0
          }
        }
      }
    },
    getGeneralNote() {
      if (this?.workClientProjectsClientReportsGeneralNote[this.$route.params.report_id]?.reportGeneralNote &&
        this?.workClientProjectsClientReportsGeneralNote[this.$route.params.report_id]?.showReportGeneralNote || this.general) {
        let result = {
          style: 'text',
          table: {
            headerRows: 1,
            widths: ['*'],
            body: [],
          },
          layout: {
            hLineColor: '#d2d5d9',
            hLineWidth: function (i) {
              return i === 0 ? 0 : 0.25
            },
            vLineWidth: function () {
              return 0
            },
            paddingTop: function () {
              return 0
            },
            paddingBottom: function () {
              return 0
            },
          }
        }
        result.table.body.push(
          [{text: this.t.general_note, style: 'black', margin: [0, 10, 0, 0], border: [false, false, false, false]}],
          [{
            text: this.general ? this.general : this?.workClientProjectsClientReportsGeneralNote[this.$route.params.report_id]?.reportGeneralNote || '',
            style: 'mt', border: [false, false, false, false]
          }]
        )
        return result
      }
    },
    getTotalTable(total) {
      let body = [
        [this.t.position, this.t.quantity, this.t.work]
      ]
      let worksCount = Object.keys(total.work_types).length
      for (let type in total) {
        let works = Object.values(total[type]).filter(i => i[this.field] > 0)
        if (type === 'extras' && works.length > 0) {
          body.push([
            {
              text: worksCount + 1,
              style: 'black'
            },
            {
              text: this.$formatTime(works.reduce((sum, cur) => {
                return sum + cur[this.field]
              }, 0)),
              style: 'black'
            },
            {
              text: this.t['total-extra'],
              style: 'black'
            }
          ])
        }
        for (let i in works) {
          body.push([
            {
              text: (type === 'extras' ? worksCount + 1 + '.' : '') + Number(Number(i) + 1),
              style: type === 'extras' ? '' : 'black'
            },
            {
              text: [
                {
                  text: works[i].is_hourly === 0
                    ? Math.round(works[i][this.field] * 100) / 100
                    : this.$formatTime(works[i][this.field]),
                  style: type === 'extras' ? '' : 'black'
                },
                {
                  text: works[i].is_hourly === 0 ? ' ' + works[i].measure : '',
                  style: 'roboto-black'
                }
              ]
            },
            {
              text: works[i].name,
              style: type === 'extras' ? '' : 'black'
            }
          ])
        }
      }
      let result = {
        style: 'text',
        margin: [0, 20, 0, 0],
        table: {
          headerRows: 1,
          widths: [45, 75, '*'],
          heights: 10,
          body: body,
        },
        layout: {
          vLineColor: '#ebebeb',
          hLineColor: '#ebebeb',
          vLineWidth: function () {
            return 0.6
          },
          hLineWidth: function () {
            return 0.6
          },
          paddingTop: function () {
            return 6
          },
          paddingBottom: function () {
            return 3
          },
          fillColor: function (i) {
            return i === 0 ? '#f2f2f2' : null
          }
        }
      }
      return body.length > 1 ? result : null
    },
    getDaysTable(data) {
      let body = this.hasNotes || this.notes
        ? [[this.t.date, this.t.quantity, this.t.work, this.t.note]]
        : [[this.t.date, this.t.quantity, this.t.work]]
      let worksCount = {
        work_types: 0,
        extras: 0
      }
      let key_day = Object.keys(data).sort()
      for (let key_day_i in key_day) {
        let day = key_day[key_day_i]
        for (let type in worksCount) {
          worksCount[type] = data[day][type]
            ? Object.values(data[day][type]).reduce((sum, cur) => {
              return sum + cur.reports.length
            }, 0)
            : 0
        }
        for (let type in worksCount) {
          if (type === 'extras' && worksCount[type] > 0) {
            let row = [
              {
                text: data[day].day,
                style: 'black',
                rowSpan: worksCount[type] + 1
              },
              {
                text: this.$formatTime(Object.values(data[day][type]).reduce((sum, cur) => {
                  return sum + cur.reports.reduce((sum, cur) => {
                    return sum + cur.value
                  }, 0)
                }, 0)),
                style: 'black'
              },
              {
                text: this.t['total-extra'],
                style: 'black'
              }
            ]
            if (this.hasNotes || this.notes) row.push('')
            body.push(row)
          }
          for (let w in data[day][type]) {
            let work = data[day][type][w]
            for (let r in work.reports) {
              let row = [
                {
                  text: data[day].day,
                  style: 'black',
                  rowSpan: worksCount.work_types + (worksCount.extras > 0 ? worksCount.extras + 1 : 0)
                },
                {
                  text: [
                    {
                      text: work.is_hourly === 0
                        ? Math.round(work.reports[r].value * 100) / 100
                        : this.$formatTime(work.reports[r].value),
                      style: type === 'extras' ? '' : 'black'
                    },
                    {
                      text: work.is_hourly === 0 ? ' ' + work.measure : '',
                      style: 'roboto-black'
                    }
                  ]
                },
                [
                  {
                    text: work.name,
                    style: type === 'extras' ? 'lh14' : ['black', 'lh14']
                  }
                ]
              ]
              if (this.hasNotes || this.notes) row.push({text: work.reports[r].notes})
              body.push(row)
            }
          }
        }
      }
      let result = {
        style: 'text',
        margin: [0, 25, 0, 5],
        table: {
          headerRows: 1,
          widths: this.hasNotes || this.notes ? [45, 75, '*', 180] : [45, 75, '*'],
          body: body,
        },
        layout: {
          vLineColor: '#ebebeb',
          hLineColor: '#ebebeb',
          vLineWidth: function () {
            return 0.6
          },
          hLineWidth: function () {
            return 0.6
          },
          paddingTop: function () {
            return 6
          },
          paddingBottom: function () {
            return 4
          },
          fillColor: function (i) {
            return i === 0 ? '#f2f2f2' : null
          }
        }
      }
      return body.length > 1 ? result : null
    },
    getImagesTable(data, e) {
      console.log('eeeeeeee', data.byDays)
      const days = Object.values(data.byDays)
      days.sort((a, b) => a.day < b.day ? -1 : 1)
      const max = this.imagesTotal[e] // Math.max(...days.map(dd => Math.max(...Object.values(dd.work_types).map(ddd => this.imagesCount.value[ddd.reports[0].id] || 1))))
      console.log('ddddd', this.imagesTotal[e])
      const col = max === 5
        ? {
          widths: [45, 75, '*', '*', '*', '*', '*'],
          body: [this.localStorage.translations.pages.finance['period-table'].position, this.localStorage.translations.pages.finance['period-table'].description, this.localStorage.translations.pages.finance['period-table'].image + ' 1', this.localStorage.translations.pages.finance['period-table'].image + ' 2', this.localStorage.translations.pages.finance['period-table'].image + ' 3', this.localStorage.translations.pages.finance['period-table'].image + ' 4', this.localStorage.translations.pages.finance['period-table'].image + ' 5']
        }
        : max === 4
          ? {
            widths: [45, 75, '*', '*', '*', '*'],
            body: [this.localStorage.translations.pages.finance['period-table'].position, this.localStorage.translations.pages.finance['period-table'].description, this.localStorage.translations.pages.finance['period-table'].image + ' 1', this.localStorage.translations.pages.finance['period-table'].image + ' 2', this.localStorage.translations.pages.finance['period-table'].image + ' 3', this.localStorage.translations.pages.finance['period-table'].image + ' 4']
          }
          : max === 3
            ? {widths: [45, 75, '*', '*', '*'], body: [this.localStorage.translations.pages.finance['period-table'].position, this.localStorage.translations.pages.finance['period-table'].description, this.localStorage.translations.pages.finance['period-table'].image + ' 1', this.localStorage.translations.pages.finance['period-table'].image + ' 2', this.localStorage.translations.pages.finance['period-table'].image + ' 3']}
            : max === 2
              ? {widths: [45, 75, '*', '*'], body: [this.localStorage.translations.pages.finance['period-table'].position, this.localStorage.translations.pages.finance['period-table'].description, this.localStorage.translations.pages.finance['period-table'].image + ' 1',  this.localStorage.translations.pages.finance['period-table'].image + ' 2']}
              : {widths: [45, 75, '*'], body: [this.localStorage.translations.pages.finance['period-table'].position, this.localStorage.translations.pages.finance['period-table'].description, this.localStorage.translations.pages.finance['period-table'].image]}
      const qq = [col.body]
      const wid = 390 / max
      const hei = 400 / max
      const fit = [wid, hei]
      const cover = {width: wid, height: hei, valign: "bottom", align: "right"}

      for (let d in days) {
        const day_key = Number(d) + 1
        console.log(days[d].work_types)
        let work = days[d].work_types ? Object.values(days[d].work_types) : null
        if (work) {
          for (let w in work) {
            let q = 0
            for (let r in work[w].reports) {
              if (work[w].reports[r]?.image?.length > 0) {
                q++
                const img = work[w].reports[r]?.image?.length || 1 //this.imagesCount.value[work[w].reports[0].id]
                console.log('work[w]work[w]work[w]', work[w].reports[r].image.length)
                console.log(work[w].reports[r]?.image)
                const row = [
                  {text: `${Number(w) + 1}${work[w].reports.length > 1 ? '.' + q : ''}`},
                  {text: `${days[d].day} ${work[w].name}`},
                  {image: work[w].reports[r]?.image[0] || 'blank', fit: fit,}// cover: cover}
                ]
                if (max >= 2) row.push(img && img >= 2 ? {
                  image: work[w].reports[r]?.image[1] || 'blank',
                  fit: fit,
                  // cover: cover
                } : {text: ''})
                if (max >= 3) row.push(img && img >= 3 ? {
                  image: work[w].reports[r]?.image[2] || 'blank',
                  fit: fit,
                  //  cover: cover
                } : {text: ''})
                if (max >= 4) row.push(img && img >= 4 ? {
                  image: work[w].reports[r]?.image[3] || 'blank',
                  fit: fit,
                  // cover: cover
                } : {text: ''})
                if (max === 5) row.push(img && img >= 5 ? {
                  image: work[w].reports[r]?.image[4] || 'blank',
                  fit: fit,
                  // cover: cover
                } : {text: ''})
                qq.push(row)
              }
            }
          }
        }
        console.log(days[d].extras)
        work = days[d].extras ? Object.values(days[d].extras) : null
        if(work){
          for (let w in work) {
            for (let r in work[w].reports) {
              if (work[w].reports[r]?.image?.length > 0) {
                const img = work[w].reports[r]?.image?.length || 1 //this.imagesCount.value[work[w].reports[0].id]
                console.log('work[w]work[w]work[w]', work[w].reports[r].image.length)
                console.log(work[w].reports[r]?.image)
                const row = [
                  {text: `${days[d].work_types ? Object.keys(days[d].work_types).length + 1 : 1}.${Number(w) + 1}`},
                  {text: `${days[d].day} ${work[w].name}`},
                  {image: work[w].reports[r]?.image[0] || 'blank', fit: fit,}// cover: cover}
                ]
                if (max >= 2) row.push(img && img >= 2 ? {
                  image: work[w].reports[r]?.image[1] || 'blank',
                  fit: fit,
                  // cover: cover
                } : {text: ''})
                if (max >= 3) row.push(img && img >= 3 ? {
                  image: work[w].reports[r]?.image[2] || 'blank',
                  fit: fit,
                  //  cover: cover
                } : {text: ''})
                if (max >= 4) row.push(img && img >= 4 ? {
                  image: work[w].reports[r]?.image[3] || 'blank',
                  fit: fit,
                  // cover: cover
                } : {text: ''})
                if (max === 5) row.push(img && img >= 5 ? {
                  image: work[w].reports[r]?.image[4] || 'blank',
                  fit: fit,
                  // cover: cover
                } : {text: ''})
                qq.push(row)
              }
            }
          }
        }
      }
      let result = {
        style: 'text',
        pageBreak: 'before',
        margin: [0, 25, 0, 5],
        table: {
          headerRows: 1,
          widths: col.widths,
          body: qq,
        },
        layout: {
          vLineColor: '#ebebeb',
          hLineColor: '#ebebeb',
          vLineWidth: function () {
            return 0.6
          },
          hLineWidth: function () {
            return 0.6
          },
          paddingTop: function () {
            return 6
          },
          paddingBottom: function () {
            return 4
          },
          fillColor: function (i) {
            return i === 0 ? '#f2f2f2' : null
          }
        }
      }
      console.log('RESULT', result)
      return result
    },
    async onDownload() {
      this.documents = []
      if (this.readyMainPDF && this.readyAllPDF) {
        this.documents.push(this.$refs['pdf-main'].getBase64())
        for (let i in this.data.employees)
          if (this.$refs['pdf-' + i]) this.documents.push(this.$refs['pdf-' + i][0].getBase64())
      }
      const mergedPdf = await PDFDocument.create()
      for (let document of this.documents) {
        document = await PDFDocument.load(document)
        const copiedPages = await mergedPdf.copyPages(document, document.getPageIndices())
        this.numberOfAdded += 1
        copiedPages.forEach((page) => mergedPdf.addPage(page))
      }
      let save = await mergedPdf.save()
      await this.downloadBlob(save, this.fileName + ' Full.pdf')
    },
    downloadBlob(data, fileName) {
      const blob = new Blob([data], {
        type: 'application/pdf',
      })
      const url = window.URL.createObjectURL(blob)
      this.downloadURL(url, fileName)
    },
    downloadURL(data, fileName) {
      const a = document.createElement('a')
      a.href = data
      a.download = fileName
      document.body.appendChild(a)
      a.style.display = 'none'
      a.click()
      a.remove()
    },
  }
}
</script>
